$eve_app_page_components_radio $eve_app_page_sb_page
	title \Radio
	Head null
	body /
		<= Radio_catalog $eve_app_page_sb_catalog
			param \radio
			spreads *
				bare <= Bare_page $eve_app_page_sb_page
					title \Bare
					body /
						<= Bare_playground $eve_app_page_sb_playground
							component_name \Live_radio
							default_source \
								\Live_radio $eve_radio
								\	colors \primary
								\	checked? true
								\	disabled? false
								\
				labelled <= Labelled_page $eve_app_page_sb_page
					title \Labelled
					body /
						<= Labelled_playground $eve_app_page_sb_playground
							component_name \Live_radio_labelled
							default_source \
								\Live_radio_labelled $eve_radio_labelled
								\	- Radio with label (based on eve_button ghost)
								\	size? \m
								\	checked? true
								\	disabled? false
								\	label \Select this option
								\
				group <= Group_page $eve_app_page_sb_page
					title \Radio Group
					body /
						<= Group_playground $eve_app_page_sb_playground
							component_name \Live_radio_group
							default_source \
								\Live_radio_group $eve_radio_group
								\	options *
								\		option1 \First Option
								\		option2 \Second Option
								\		option3 \Third Option
								\	value? \option1
								\
